import { ArrowBigUpDashIcon } from 'lucide-react'

import { UpgradeSdaiAction } from './types'
import { ActionRow } from '@/features/actions/components/action-row/ActionRow'
import { ActionRowBaseProps } from '@/features/actions/components/action-row/types'

export interface UpgradeSdaiActionRowProps extends ActionRowBaseProps {
  action: UpgradeSdaiAction
}

export function UpgradeSdaiActionRow({ action: { sdai, susds, amount }, ...props }: UpgradeSdaiActionRowProps) {
  return (
    <ActionRow {...props}>
      <ActionRow.Icon icon={ArrowBigUpDashIcon} />

      <ActionRow.Title>
        <ActionRow.Title.Tokens tokens={[sdai, susds]} />
        Upgrade {sdai.symbol} to {susds.symbol}
      </ActionRow.Title>

      <ActionRow.Amount token={sdai} amount={amount} />

      <ActionRow.ErrorWarning />

      <ActionRow.Trigger>Upgrade</ActionRow.Trigger>
    </ActionRow>
  )
}
